export class NewDeputyDTOModel {
	FieldCollectionId: number;

	constructor(fieldCollectionId: number) {
		this.FieldCollectionId = fieldCollectionId;
	}
}